import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';

export const PARTICIPATION_NOTE_SETTINGS = {
  id: ProductTypeEnum.PARTICIPATION_NOTE,
  label: 'Participation Note',
  effects: [
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
      readOnly: false,
    },
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_TYPE],
      selectValues: ['CALL'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
      selectValues: ['FIXED'],
      hidden: false,
      readOnly: false,
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
      ],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.NONE],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
      ],
      readOnly: false,
    },
  ],
};
